import { PropsWithChildren } from "react";
import { Bios, ProjectTypes } from "../types";
import { capitaliseFirstLetter } from "../utils/capitaliseFirstLetter";

interface MenuTabProps {
  header: string;
  currentTab: Bios | ProjectTypes;
  onClick: (name: any) => void;
}

export const MenuTab = ({
  header,
  onClick,
  currentTab,
}: PropsWithChildren<MenuTabProps>) => {
  const key = capitaliseFirstLetter(header);

  return (
    <button
      className={`text-base md:text-xl px-3 py-2 md:px-4 md:py-2 hover:scale-105 duration-300 transition-all ${
        currentTab === key
          ? "font-semibold text-gray-100 border-b-[3px] border-violet-500"
          : "text-gray-400 hover:text-gray-300"
      }`}
      onClick={() => onClick(key)}
    >
      {header}
    </button>
  );
};
